import { jsx } from 'react/jsx-runtime';
import { Primitive } from '@radix-ui/react-primitive';
import { forwardRef } from 'react';
import { useSingleSelectOptionContext } from '../../contexts/option-context.mjs';

const SingleSelectOptionIndicator = forwardRef((props, forwardedRef) => {
  const { selected } = useSingleSelectOptionContext("OptionIndicator");
  return /* @__PURE__ */ jsx(
    Primitive.div,
    {
      "aria-hidden": true,
      "data-scope": "single-select",
      "data-part": "option-indicator",
      hidden: !selected,
      ref: forwardedRef,
      ...props
    }
  );
});

export { SingleSelectOptionIndicator as SelectOptionIndicator };
//# sourceMappingURL=OptionIndicator.mjs.map
